export default "__VITE_ASSET__$DrXW9E$__"